<template>
    <div class="wrapper">
        <side-bar :auto-close="autoClose">
            <template #links>
                <sidebar-link
                    to="/materials"
                    name="словарь материалов"
                    icon="tim-icons icon-chart-pie-36"
                />
                <sidebar-link
                    to="/works"
                    name="словарь работ"
                    icon="tim-icons icon-chart-pie-36"
                />
                <sidebar-link
                    to="/technologies"
                    name="словарь технологий"
                    icon="tim-icons icon-chart-pie-36"
                />
                <sidebar-link
                    to="/projects"
                    name="проекты"
                    icon="tim-icons icon-chart-pie-36"
                />
            </template>
        </side-bar>

        <div class="main-panel">
            <top-navbar />
            <dashboard-content @click="toggleSidebar" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ISidebar } from '@/App.vue';

const DESKTOP_BREAKPOINT = 992;

const autoClose = ref(false); // нужно ли сворачивать навигационное меню, при клике на контент страницы
const sidebar = inject<ISidebar>('sidebar');
const resizeObserver = ref<ResizeObserver | null>(null);

const toggleSidebar = () => {
    if (sidebar?.showSidebar && autoClose.value) {
        sidebar.displaySidebar(false);
    }
};

onMounted(() => {
    const mainPage = document.body;
    if (!mainPage) return;

    resizeObserver.value = new ResizeObserver((entries) => {
        for (const entry of entries) {
            const { inlineSize: width } = entry.contentBoxSize[0];
            autoClose.value = width <= DESKTOP_BREAKPOINT;
        }
    });

    resizeObserver.value.observe(mainPage);
});

onBeforeUnmount(() => {
    if (resizeObserver.value) {
        resizeObserver.value.disconnect();
    }
});
</script>
